import User from './user/user.service.js';
import Ecourses from './ecourse/ecourses.factory.js';
import EcourseFactory from './ecourse/ecourse.factory.js';
import Alerts from './alerts/alerts.service.js';
import Util from './util/util.factory.js';
import TimerService from './timer/timer.service.js';
import MenuService from './menuService/menuService.js';
import ViewsService from './views/views.service.js';
import BraintreeHostedFieldsService from './hostedFields/braintreeFields.service.js';

angular.module('app.services', ['ngCookies'])
  .factory('Util', Util)
  .factory('EcourseFactory', EcourseFactory)
  .factory('Ecourses', Ecourses)
  .factory('MenuService', MenuService)
  .service('TimerService', TimerService)
  .service('Alerts', Alerts)
  .service('User', User)
  .service('ViewsService', ViewsService)
  .service('BraintreeForm', BraintreeHostedFieldsService);




/** WEBPACK FOOTER **
 ** ./src/app/services/services.module.js
 **/